import React from 'react';
import User from './../assets/images/user.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { clickExtendPremium } from '../services/amplitude';
import { useSelector } from 'react-redux';
import { formatDate } from '../helper';

const ProfileModal = () => {
  const { day_left } = useSelector((state) => state.user);

  const userProfile = useSelector((state) => state.user.user_profile);

  return (
    <div
      className="modal fade"
      id="modal-profile"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-md" style={{ minWidth: 350 }} role="document">
        <div className="modal-content">
          <div className="d-flex justify-content-end pt-3 pr-3 text-danger">
            <button
              data-dismiss="modal"
              style={{
                width: 25,
                height: 25,
                outline: 'none',
                fontSize: 20,
                border: 'none',
                backgroundColor: '#ffffff',
                color: '#9c9595',
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div className="modal-body text-center pb-4">
            <img src={User} style={{ width: 100, height: 100 }} alt="user" />
            {userProfile && userProfile.users.Name !== null && <h3 className="mt-3">{userProfile.users.Name}</h3>}
            {userProfile && userProfile.users.Email !== null && (
              <p className="mt-3 text-secondary fs-4">{userProfile.users.Email}</p>
            )}

            <h4 className="m-3 fs-5">{localStorage.getItem('status') === '1' || !localStorage.getItem('status') ? 'Personal User' : 'Premium User'}</h4>

            {localStorage.getItem('due') !== null && (
              <span
                className="px-3 py-1 text-white"
                style={{ fontSize: 16, backgroundColor: '#f05377', borderRadius: 15 }}
              >
                {`Subscribe until ${formatDate(localStorage.getItem('due'))}`}
              </span>
            )}
            <div
              className={`mt-4 ${day_left < 7 ? 'd-block' : 'd-none'}`}
              style={{
                width: '100%',
                height: 1.5,
                backgroundColor: 'rgba(189, 185, 185, 0.3)',
              }}
            />
            <div className={`p-3 ${day_left < 7 ? 'd-block' : 'd-none'}`}>
              <p style={{ fontSize: 14, margin: 0 }}>
                Perpanjang akun premium Anda
                <button
                  data-dismiss="modal"
                  data-toggle="modal"
                  data-target="#modal-extend-premium"
                  style={{
                    color: '#82be2a',
                    textDecoration: 'none',
                    backgroundColor: 'transparent',
                    border: 0,
                    fontWeight: 'bolder',
                  }}
                  onClick={() => clickExtendPremium()}
                >
                  klik di sini
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileModal;
